import { render, staticRenderFns } from "./DriverDocumentsWidget.vue?vue&type=template&id=04532854&scoped=true&"
import script from "./DriverDocumentsWidget.vue?vue&type=script&lang=js&"
export * from "./DriverDocumentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./DriverDocumentsWidget.vue?vue&type=style&index=0&id=04532854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04532854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04532854')) {
      api.createRecord('04532854', component.options)
    } else {
      api.reload('04532854', component.options)
    }
    module.hot.accept("./DriverDocumentsWidget.vue?vue&type=template&id=04532854&scoped=true&", function () {
      api.rerender('04532854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/DriverDocumentsWidget.vue"
export default component.exports